import React from "react";
import { LeftCaret, RightCaret } from "./Icons/Carets";

export default function PanelCollapser({toggleFunction,inversed}:{toggleFunction:Function,inversed?:boolean}){


    let cls = (inversed)?"left":"right";

    return (
        <div className="h-full no-shrink center-all panel-collapser" style={{width:"12px",cursor:"pointer",color:"#999"}}
                        
        onClick={()=>{

            toggleFunction();
            // let grid = document.querySelector(".main-grid-container");
            // if(grid){
            //     grid.classList.toggle(toggleClass);
            // }


        }}
        
        > 
        <div className={cls+"-expanded"}>
           {inversed?<LeftCaret/>: <RightCaret/>}
        </div>
        <div className={cls +"-collapsed"}>
        {inversed?<RightCaret/>: <LeftCaret/>}
        </div>
        
        </div>
    )
}